function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  rx: 15,
  fill: "#4A90E2",
  fillOpacity: 0.15
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7304 15.7751C14.38 15.7751 15.7173 14.4823 15.7173 12.8876C15.7173 11.2928 14.38 10 12.7304 10C11.0808 10 9.74353 11.2928 9.74353 12.8876C9.74353 14.4823 11.0808 15.7751 12.7304 15.7751Z",
  stroke: "#4A90E2",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3844 15.4435C21.4743 15.4435 22.3578 14.5599 22.3578 13.47C22.3578 12.3801 21.4743 11.4965 20.3844 11.4965C19.2944 11.4965 18.4109 12.3801 18.4109 13.47C18.4109 14.5599 19.2944 15.4435 20.3844 15.4435Z",
  stroke: "#4A90E2",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.25 19.9775C8.13695 18.6622 10.4042 17.9545 12.7305 17.9545C15.0567 17.9545 17.324 18.6622 19.2109 19.9775",
  stroke: "#4A90E2",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4242 17.9103C18.2861 17.2688 19.3218 16.9236 20.3844 16.9236C21.447 16.9236 22.4827 17.2688 23.3446 17.9103",
  stroke: "#4A90E2",
  strokeLinejoin: "round"
});

var SvgBranchCustomer = function SvgBranchCustomer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBranchCustomer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/branch-customer.bcfcee76.svg";
export { ForwardRef as ReactComponent };